import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SelectOption = ({className, optionValue, optionText, onClick, dataQa}) => {
    const selectOptionClassName = classNames('ace-c-select__option', className);

    return (
        <div
            className={selectOptionClassName}
            id={optionValue}
            onClick={() => onClick(optionValue)}
            data-qa={dataQa || `select-option-${optionValue}`}
        >
            {optionText}
        </div>
    );
};

SelectOption.propTypes = {
    className: PropTypes.string,
    optionValue: PropTypes.string,
    optionText: PropTypes.string,
    onClick: PropTypes.func,
    dataQa: PropTypes.string,
};

SelectOption.defaultProps = {
    className: '',
    optionText: '',
    optionValue: '',
    onClick: null,
    dataQa: '',
};

export default SelectOption;
